import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {Player} from "@/modules/team/entity";
import {AfterDayEvaluationEvent} from "@/modules/season/events/AfterDayEvaluationEvent";
import MarketValueCalculator from "@/modules/team/services/MarketValueCalculator";

@injectable()
export class PlayerMarketValueEventSubscriber implements EventSubscriber {
  constructor(
    @inject(MarketValueCalculator) private marketValueCalculator: MarketValueCalculator,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterDayEvaluationEvent, callback: this.onAfterDayEvaluationEvent},
    ];
  }

  async onAfterDayEvaluationEvent(event: AfterDayEvaluationEvent) {
    if (event.season.currentDate.date() > 28) {
      return;
    }

    const players = await Player
      .createQueryBuilder('player')
      .where(
        'player.id % 28 = :currentDay',
        {currentDay: event.season.currentDate.date() - 1}
      )
      .getMany();

    await players.forEachAsync(async (p: Player) => {
      p.marketValue = await this.marketValueCalculator.calculate(p);
      await p.save();
    });

    console.debug(`players market value updated`, {players});
  }
}